<template>
  <div class="select">
    <div :class="`tab ${noIcon && 'noIcon'}`" @click="visible = true" v-if="!month">
      <Iconfont name="iconrilitubiao" className="icon" v-if="!noIcon"></Iconfont>
      <span>{{ timeFromat }}</span>
      <span class="tips">{{ $t('common.day' + dateFromat) }}</span>
      <Icon name="arrow-down" color="#949AA4" size="0.5rem" />
    </div>
    <div class="tab" @click="visible = true" v-else>
      <Iconfont name="iconrilitubiao" className="icon"></Iconfont>
      <span>{{ monthFromat }}</span>
      <Icon name="arrow-down" color="#949AA4" size="0.5rem" />
    </div>
    <Popup v-model="visible" position="bottom">
      <DatetimePicker
        v-model="date"
        :type="month ? 'year-month' : 'date'"
        @cancel="visible = false"
        :min-date="noMin ? zeroDate : minDate"
        show-toolbar
        @confirm="onConfirm"
        :formatter="formatter"
      />
    </Popup>
  </div>
</template>

<script>
import moment from 'moment';
import { DatetimePicker, Popup } from 'vant';
import { Icon } from 'vant';
import Iconfont from '@/components/icon.vue';
import dateIcon from '@/assets/icon/date.svg';
export default {
  props: ['value', 'placeholder', 'month', 'noIcon', 'noMin'],
  components: { DatetimePicker, Popup, Icon, Iconfont },
  data() {
    return {
      dateIcon,
      visible: false,
      minDate: new Date(moment().format('YYYY-MM-DD')),
      zeroDate: new Date(
        moment()
          .add(-10, 'years')
          .format('YYYY-MM-DD')
      ),
      date: this.value,
    };
  },
  computed: {
    timeFromat() {
      return moment(this.value).format('YYYY-MM-DD');
    },
    monthFromat() {
      return moment(this.value).format('YYYY-MM');
    },
    dateFromat() {
      return moment(this.value).day();
    },
  },
  methods: {
    onConfirm(value) {
      this.$emit('update:value', value);
      this.visible = false;
    },
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      return val;
    },
  },
};
</script>

<style lang="less" scoped>
.select {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.tab {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .icon {
    width: 44px;
    margin-right: 20px;
  }
  span {
    font-size: 34px;
    color: #363d4d;
    margin-right: 10px;
    &.tips {
      font-size: 24px;
      color: #949aa4;
    }
  }

  &.noIcon {
    span {
      font-size: 24px;
      color: #363d4d;
    }
  }
}
</style>
